

const widget = document.querySelector(".contact-widget");
const closedWidget = document.querySelector(".closed-widget");
const openWidget = document.querySelector(".open-widget");
const cross = document.querySelector('.close-icon');

closedWidget.addEventListener('click', openContactWidget);
cross.addEventListener('click', closeContactWidget);


function openContactWidget(){
    closedWidget.classList.add('hide')
    openWidget.classList.remove('hide');
    widget.classList.add('open');
}

function closeContactWidget(){
    closedWidget.classList.remove("hide");
    openWidget.classList.add("hide");
    widget.classList.remove("open");
}



